import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

// export const PriceFilter = createAsyncThunk(
//   "priceRange/PriceFilter",
//   async (filterData, thunkAPI) => {
//     console.log("filterData PriceFilter", filterData)
//     try {
//       const response = await axios.get(
//         `${endPoint.FILTERPRODUCT}?${filterData?.name}=${encodeURIComponent(
//           filterData?.Catename
//         )}&${filterData?.price}=${filterData?.priceRanges}`
//       );
//       return response?.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.message);
//     }
//   }
// );

export const PriceFilter = createAsyncThunk(
  "priceRange/PriceFilter",
  async (filterData, page, limit = 50, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endPoint.FILTERPRODUCT}?${filterData?.name}=${encodeURIComponent(filterData?.Catename)}&${filterData?.price}=${filterData?.priceRanges}&page=${page}&limit=${limit}`
      );
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const PriceFilterSlice = createSlice({
  name: "PriceFilterData",
  initialState: {
    PriceFilterData: [],
    currentPage: 1,
    totalPagesPrice: 0,
    totalItems: 0,
    error: null,
  },
  reducers: {
    clearPriceFilterData: (state) => {
      state.PriceFilterData = [];
      state.currentPage = 1;
      state.totalPagesPrice = 0;
      state.totalItems = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(PriceFilter.fulfilled, (state, action) => {
        state.PriceFilterData = action.payload || [];
        state.currentPage = action.payload?.currentPage || 1;
        state.totalPagesPrice = action.payload?.totalPages || 0;
        state.totalItems = action.payload?.totalItems || 0;
      })
      .addCase(PriceFilter.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

// const PriceFilterSlice = createSlice({
//   name: "PriceFilterData",
//   initialState: {
//     PriceFilterData: [],
//     error: null,
//   },
//   reducers: {
//     clearPriceFilterData: (state) => {
//       state.PriceFilterData = [];
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(PriceFilter.fulfilled, (state, action) => {
//         state.PriceFilterData = action.payload;
//       })
//       .addCase(PriceFilter.rejected, (state, action) => {
//         state.error = action.payload;
//       });
//   },
// });
export const { clearPriceFilterData } = PriceFilterSlice.actions;
export default PriceFilterSlice.reducer;
